export default __webpack_public_path__ + "static/media/thermometer-cold.2fe3fd13.svg";